import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ChevronDoubleLeft = (props: SvgIconT.Props) => (
  <SvgIcon
    width={16}
    height={16}
    {...props}
    viewBox="0 0 16 16"
    paths={[
      'M0,8c0,0.1,0,0.2,0.1,0.3l5.6,7.5c0.2,0.2,0.5,0.3,0.7,0.1c0.2-0.2,0.3-0.5,0.1-0.7L1.1,8l5.4-7.2c0.2-0.2,0.1-0.5-0.1-0.7C6.2-0.1,5.9,0,5.7,0.2L0.1,7.7C0,7.8,0,7.9,0,8L0,8z M9,8c0,0.1,0,0.2,0.1,0.3l5.6,7.5c0.2,0.2,0.5,0.3,0.7,0.1c0.2-0.2,0.3-0.5,0.1-0.7L10.1,8l5.4-7.2c0.2-0.2,0.1-0.5-0.1-0.7c-0.2-0.2-0.5-0.1-0.7,0.1L9.1,7.7C9,7.8,9,7.9,9,8L9,8z',
    ]}
  />
);

export default ChevronDoubleLeft;
